export default __webpack_public_path__ + "static/media/ic-notification-outline.113ebf4a.svg";